import { State } from "./State";
export class QuestionGrid {
    constructor(columns, rows) {
        this.columns = new State(columns);
        this.rows = new State(rows);
    }
    addColumn(column) {
        this.columns.value.push(column);
        this.columns.set();
    }
    quitColumn(columnId) {
        const index = this.columns.value.findIndex(({ id }) => id === columnId);
        if (index === -1) {
            return;
        }
        this.columns.value.splice(index, 1);
        this.columns.set();
    }
    columnUp(columnId) {
        const index = this.columns.value.findIndex(({ id }) => id === columnId);
        if (index <= 0) {
            return;
        }
        const [column] = this.columns.value.splice(index, 1);
        this.columns.value.splice(index - 1, 0, column);
        this.columns.set();
    }
    columnDown(columnId) {
        const index = this.columns.value.findIndex(({ id }) => id === columnId);
        if (index === -1 || index === this.columns.value.length - 1) {
            return;
        }
        const [column] = this.columns.value.splice(index, 1);
        this.columns.value.splice(index + 1, 0, column);
        this.columns.set();
    }
    rowUp(rowId) {
        const index = this.rows.value.findIndex(({ id }) => id === rowId);
        if (index <= 0) {
            return;
        }
        const [row] = this.rows.value.splice(index, 1);
        this.rows.value.splice(index - 1, 0, row);
        this.rows.set();
    }
    rowDown(rowId) {
        const index = this.rows.value.findIndex(({ id }) => id === rowId);
        if (index === -1 || index === this.rows.value.length - 1) {
            return;
        }
        const [row] = this.rows.value.splice(index, 1);
        this.rows.value.splice(index + 1, 0, row);
        this.rows.set();
    }
    addRow(row) {
        this.rows.value.push(row);
        this.rows.set();
    }
    quitRow(rowId) {
        const index = this.rows.value.findIndex(({ id }) => id === rowId);
        if (index === -1) {
            return;
        }
        this.rows.value.splice(index, 1);
        this.rows.set();
    }
    toJSON() {
        return {
            columns: [...this.columns.value],
            rows: [...this.rows.value],
        };
    }
}
